import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslatorService {
  private DEFAULT_LANGUAGE_KEY = 'DEFAULT_LANGUAGE';
  private CURRENT_LANGUAGE_KEY = 'CURRENT_LANGUAGE';

  constructor(private translateService: TranslateService) {
    const defaultLanguage = localStorage.getItem(this.DEFAULT_LANGUAGE_KEY);
    if (defaultLanguage && defaultLanguage.length > 0) {
      this.translateService.setDefaultLang(defaultLanguage);
    } else {
      this.DefaultLanguage = 'en';
    }

    const currentLanguage = localStorage.getItem(this.CURRENT_LANGUAGE_KEY);
    if (currentLanguage && currentLanguage.length > 0) {
      this.translateService.use(currentLanguage);
    }
  }

  public set DefaultLanguage(language: string) {
    this.translateService.setDefaultLang(language);
    localStorage.setItem(this.DEFAULT_LANGUAGE_KEY, language);
  }

  public get DefaultLanguage(): string {
    return localStorage.getItem(this.DEFAULT_LANGUAGE_KEY);
  }

  public set CurrentLanguage(language: string) {
    this.translateService.use(language);
    localStorage.setItem(this.CURRENT_LANGUAGE_KEY, language);
  }

  public get CurrentLanguage(): string {
    return localStorage.getItem(this.CURRENT_LANGUAGE_KEY);
  }
}
